module.exports = __webpack_public_path__ + "img/fushimi-HP-nyuka-image001sp.6bbb8d73.jpg";